import * as Types from '../constants/actionTypes';



export default (state = {}, action) => {
    switch(action.type){
        case Types.TAKEBACKOPTIONS_DETAIL:
            return Object.assign({}, state, {isPanding : true})
        case Types.TAKEBACKS_DETAIL_SUCCESS:
            return Object.assign({}, state, {Takebacks : action.payload, isPanding:false})    
        case Types.TAKEBACKS_DETAIL_ERROR:
            return Object.assign({}, state, {error: action.payload, isPanding:false})
        case Types.TAKEBACKOPTIONS_ADDED:
            return Object.assign({}, state, {isPanding : true})
        case Types.TAKEBACKOPTIONS_ADDED_SUCCESS:
            return Object.assign({}, state, {addStatus : action.payload, isPanding:false})    
        case Types.TAKEBACKOPTIONS_ADDED_ERROR:
            return Object.assign({}, state, {error: action.payload, isPanding:false})
        case Types.TAKEBACKOPTIONS_DELETED:
            return Object.assign({}, state, {isPanding : true})
        case Types.TAKEBACKOPTIONS_DELETED_SUCCESS:
            return Object.assign({}, state, {deleteStatus : action.payload, isPanding:false})    
        case Types.TAKEBACKOPTIONS_DELETED_ERROR:
            return Object.assign({}, state, {error: action.payload, isPanding:false})
        case Types.TAKEBACKOPTIONS_UPDATE_SUCCESS:
            return Object.assign({}, state, {updateStatus : action.payload, isPanding:false})      
        default : 
            return state   
    }
}

// export const takebacksRender = (state={isPanding:false, Takebacks:[], error:''}, action)=>{
//     switch(action.type){
        
//     }
// }


// export const takebacksAddRender = (state={isPanding:false, status:"", error:''}, action)=>{
//     switch(action.type){
        
//         default : 
//             return state   
//     }
// }

// export const takebacksDeleteRender = (state={isPanding:false, status:"", error:''}, action)=>{
//     switch(action.type){
        
//         default : 
//             return state   
//     }
// }